// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-bulk-upload-container {
  padding: 0 15px;
  margin-bottom: 30px;
}

.products-bulk-upload-container .progress {
  height: 40px;
}

.products-bulk-upload-container .progress .progress-bar {
  line-height: 40px;
}

.products-bulk-upload-container .products-bulk-drop-zone {
  min-height: 300px;
  width: 100%;
  cursor: pointer;
  border: 1px dotted #111c26;
  padding: 135px 10px;
  font-size: 18px;
  font-weight: bold;
}

.products-bulk-upload-container .drop-zone {
  min-height: 300px;
}

.products-bulk-drop-zone input {
  width: 100%;
}

.img-bulk-flex-container {
  display: -webkit-flex;
  -webkit-align-items: center;
  display: flex;
  align-items: center;
}

.img-bulk-flex-container .item1 {
  -webkit-flex: 1;
  flex: 1;
}

.alert-error-message {
  margin-top: 20px;
  color: #a94442;
  background-color: #f2dede;
  padding: 10px 10px;
  border: 1px solid #ebccd1;
  font-weight: 700;
}

.margin-top-25 {
  margin-top: 25px;
}

.image-display-container {
  display: flex;
  margin-top: 40px;
}

.drop-image-preview {
  position: relative;
  display: inline-block;
  width: 120px;
  height: 120px;
  margin: 10px 5px 0 0;
  cursor: pointer;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
}

.drop-image-preview img {
  width: 120px;
  height: 120px;
  object-fit: cover;
}

.image-original-name {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.image-original-name {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px;
  font-size: 11px;
  text-align: center;
}

.remove-selected-file {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}

.remove-selected-file a,
.remove-selected-file button {
  padding: 9px !important;
  color: #fff;
  background-color: #9f191f;
  border: none;
}

.remove-selected-file button.glyphicon-plus {
  background-color: #5cb85c;
}

.margin-top-40 {
  margin-top: 40px;
}

.margin-top-50 {
  margin-top: 50px;
}
`, "",{"version":3,"sources":["webpack://./client/components/dashboard/filesUpload/imagesBulkUpload/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".products-bulk-upload-container {\n  padding: 0 15px;\n  margin-bottom: 30px;\n}\n\n.products-bulk-upload-container .progress {\n  height: 40px;\n}\n\n.products-bulk-upload-container .progress .progress-bar {\n  line-height: 40px;\n}\n\n.products-bulk-upload-container .products-bulk-drop-zone {\n  min-height: 300px;\n  width: 100%;\n  cursor: pointer;\n  border: 1px dotted #111c26;\n  padding: 135px 10px;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.products-bulk-upload-container .drop-zone {\n  min-height: 300px;\n}\n\n.products-bulk-drop-zone input {\n  width: 100%;\n}\n\n.img-bulk-flex-container {\n  display: -webkit-flex;\n  -webkit-align-items: center;\n  display: flex;\n  align-items: center;\n}\n\n.img-bulk-flex-container .item1 {\n  -webkit-flex: 1;\n  flex: 1;\n}\n\n.alert-error-message {\n  margin-top: 20px;\n  color: #a94442;\n  background-color: #f2dede;\n  padding: 10px 10px;\n  border: 1px solid #ebccd1;\n  font-weight: 700;\n}\n\n.margin-top-25 {\n  margin-top: 25px;\n}\n\n.image-display-container {\n  display: flex;\n  margin-top: 40px;\n}\n\n.drop-image-preview {\n  position: relative;\n  display: inline-block;\n  width: 120px;\n  height: 120px;\n  margin: 10px 5px 0 0;\n  cursor: pointer;\n  border: 1px solid #cdcdcd;\n  border-radius: 4px;\n}\n\n.drop-image-preview img {\n  width: 120px;\n  height: 120px;\n  object-fit: cover;\n}\n\n.image-original-name {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.image-original-name {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  padding: 5px;\n  font-size: 11px;\n  text-align: center;\n}\n\n.remove-selected-file {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n}\n\n.remove-selected-file a,\n.remove-selected-file button {\n  padding: 9px !important;\n  color: #fff;\n  background-color: #9f191f;\n  border: none;\n}\n\n.remove-selected-file button.glyphicon-plus {\n  background-color: #5cb85c;\n}\n\n.margin-top-40 {\n  margin-top: 40px;\n}\n\n.margin-top-50 {\n  margin-top: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
